import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Lock, ArrowRight, Loader2, ArrowLeft } from 'lucide-react';
export function PortalVerifyOtp({ tenantSlug, email, onBack, onVerified }) {
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const inputs = Array.from({ length: 6 });
    const buildApiUrl = (path) => {
        const envBase = (import.meta.env.VITE_API_URL ?? '/').trim();
        const invalidHostOnly = /^https?:\/\/[a-z0-9-]+$/i.test(envBase);
        const normalizedBase = !envBase || invalidHostOnly
            ? '/'
            : envBase.endsWith('/')
                ? envBase
                : `${envBase}/`;
        return `${normalizedBase}${path.replace(/^\//, '')}`;
    };
    const handleChange = (idx, val) => {
        if (!/^\d?$/.test(val))
            return;
        const next = [...otp];
        next[idx] = val;
        setOtp(next);
        if (val && idx < 5) {
            const nextInput = document.getElementById(`otp-${idx + 1}`);
            nextInput?.focus();
        }
    };
    const handleKeyDown = (idx, e) => {
        if (e.key === 'Backspace' && !otp[idx] && idx > 0) {
            const prev = document.getElementById(`otp-${idx - 1}`);
            prev?.focus();
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const code = otp.join('');
        if (code.length < 6) {
            setError('Ingresa los 6 dígitos');
            return;
        }
        setError('');
        setLoading(true);
        try {
            const res = await fetch(buildApiUrl('/api/v1/portal/verify-otp'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ tenantSlug, email, otp: code }),
            });
            if (!res.ok) {
                const data = await res.json();
                throw new Error(data.message ?? 'Código incorrecto');
            }
            const json = await res.json();
            onVerified(json.token, json.portal);
        }
        catch (err) {
            setError(err.message);
            setOtp(['', '', '', '', '', '']);
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsxs("div", { className: "animate-fade-in", children: [_jsxs("button", { onClick: onBack, className: "flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-6", children: [_jsx(ArrowLeft, { className: "w-4 h-4" }), " Volver"] }), _jsxs("div", { className: "text-center mb-8", children: [_jsx("div", { className: "w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-3", children: _jsx(Lock, { className: "w-7 h-7 text-blue-600" }) }), _jsx("h2", { className: "text-2xl font-bold text-gray-900 mb-2", children: "C\u00F3digo de verificaci\u00F3n" }), _jsxs("p", { className: "text-gray-600 text-sm", children: ["Ingres\u00E1 el c\u00F3digo que enviamos a", _jsx("br", {}), _jsx("strong", { children: email })] })] }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsx("div", { className: "flex justify-center gap-3 mb-6", children: inputs.map((_, i) => (_jsx("input", { id: `otp-${i}`, type: "text", inputMode: "numeric", maxLength: 1, value: otp[i], onChange: e => handleChange(i, e.target.value), onKeyDown: e => handleKeyDown(i, e), className: "w-12 h-14 text-center text-2xl font-bold border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all", autoFocus: i === 0 }, i))) }), error && (_jsx("div", { className: "bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm text-center mb-4", children: error })), _jsxs("button", { type: "submit", disabled: loading || otp.join('').length < 6, className: "w-full flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white font-semibold rounded-xl transition-all", children: [loading ? _jsx(Loader2, { className: "w-5 h-5 animate-spin" }) : _jsx(ArrowRight, { className: "w-5 h-5" }), loading ? 'Verificando...' : 'Verificar'] })] })] }));
}
//# sourceMappingURL=PortalVerifyOtp.js.map